import { Link } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuthStore } from '../../store/authStore'
import BrandLogo from '../../components/BrandLogo/BrandLogo'
import './LandingPage.css'
import './BlogPage.css'
import '../../tokens/shared.css'

type BlogShellProps = {
  children: ReactNode
}

export default function BlogShell({ children }: BlogShellProps) {
  const { isAuthenticated } = useAuthStore()

  return (
    <div className="kmin blog-page bg-[#07070A] text-white min-h-screen font-sans">
      <div className="kmin-glow">
        <div className="kmin-glow-top" />
        <div className="kmin-glow-bottom" />
      </div>

      <header className="kmin-nav">
        <div className="kmin-container">
          <div className="kmin-nav-inner">
            <BrandLogo variant="landing" to="/" linkClassName="blog-logo-link" />
            <nav className="kmin-nav-links" aria-label="Навигация блога">
              <Link to="/blog">Новости</Link>
              <Link to="/">Главная</Link>
            </nav>
            <div className="kmin-nav-actions">
              <Link
                to={isAuthenticated ? '/dashboard' : '/register'}
                className="kmin-btn-primary kmin-nav-cta"
                style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }}
              >
                {isAuthenticated ? 'В приложение' : 'Начать'}
              </Link>
            </div>
          </div>
        </div>
      </header>

      <main className="blog-main">{children}</main>

      <footer className="kmin-footer">
        <div className="kmin-container">
          <div className="kmin-footer-inner">
            <div>
              <BrandLogo variant="landing-sm" to="/" />
              <div className="kmin-footer-sub">Блог разработчика — новости продукта</div>
            </div>
            <div className="kmin-footer-links">
              <Link to="/blog" className="kmin-footer-link-btn">Новости</Link>
              <Link to="/" className="kmin-footer-link-btn">Главная</Link>
              <Link to="/support" className="kmin-footer-link-btn">Поддержка</Link>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
